import { render, staticRenderFns } from "./azure-file.vue?vue&type=template&id=3303428a&"
import script from "./azure-file.vue?vue&type=script&lang=js&"
export * from "./azure-file.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports